import store from '@/store'
import { Loading } from 'element-ui'

const state = {
  storeInfo: {},
  storeList: [],
  tags:[]
}

const mutations = {
  SET_STOREINFO: (state, storeInfo) => {
    state.storeInfo = storeInfo
  },
  SET_STORELIST: (state, storeList) => {
    state.storeList = storeList
  }
}

const actions = {
  async getStoreList({ commit, dispatch }, storeList) {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async resolve => {
      commit('SET_STORELIST', storeList)
      let storeItem = JSON.parse(window.sessionStorage.getItem('storeInfoNow'))
      let isHave = false
      if (storeItem){
        isHave = storeList.find(val => {
          return storeItem.storeId === val.storeId
        })
      } else {
        isHave = false
      }
      let obj = {}
      if (isHave) {
        // obj = storeItem
        obj = isHave
      } else {
        obj = storeList[0]
      }
      await dispatch('changeStore', obj)
      resolve()
    })
  },
  // dynamically modify permissions
  changeStore({ commit }, storeInfo) {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async resolve => {
      const loadingInstance1 = Loading.service({ fullscreen: true, text: '正在更新基础数据' })
      let arrAuth = []
      if (storeInfo.permissions.includes('doctor_hosp_data')){
        arrAuth.push('doctor_hosp_data')
      }
      //todo 删除
      arrAuth.push('doctor_hosp_data')

      storeInfo.dataResources = arrAuth
      commit('SET_STOREINFO', storeInfo)
      await store.dispatch('permission/generateRoutes', storeInfo.permissions)
      resolve()
      setTimeout(() => {
        loadingInstance1.close()
      }, 1000)
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
